import React from "react";
import Card from "../Card";
import { useEffect } from "react";
import { Grid } from "@mui/material";
import { ReactComponent as PhoneIcon } from "../../../Assets/Icons/PhoneIcon.svg";
import { db } from "../../db";

const StoreInfo = (props) => {
  const storeLocation = props?.StoreDetails?.storeLocation?.split(",")[0];
  const storeManagerPhone =
    props?.Cart?.storeid?.storeManagerMobile ??
    props?.StoreDetails?.storeManagerPhone;
  const bussinessType = props?.Cart?.storeid?.businessType;
  console.log("bussinessType", bussinessType);
  useEffect(() => {
    props.getStores(
      localStorage.getItem("lattitude"),
      localStorage.getItem("longitude")
    );
    props.getStoreDetails(localStorage.getItem("storeid"));
  }, []);
  return (
    <>
      <Card hasBorder={true} borderPosition={"top"}>
        {bussinessType && (
          <Grid container style={{ display: "flex", alignItems: "center" }}>
            <Grid
              item
              xs={0.5}
              sm={0.5}
              md={0.5}
              style={{ display: "flex", alignItems: "center" }}
            >
              {bussinessType === "Restaurants & Bakery " ? (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                >
                  <path
                    d="M11.3833 6.93134C11.7337 6.9323 12.0808 6.86374 12.4046 6.72962C12.7283 6.5955 13.0222 6.39849 13.2693 6.15L15.836 3.58501C16.039 3.38201 16.0576 3.05167 15.8643 2.83867C15.8158 2.78516 15.7569 2.74206 15.6912 2.712C15.6255 2.68194 15.5543 2.66554 15.4821 2.66379C15.4099 2.66205 15.3381 2.67499 15.271 2.70185C15.2039 2.7287 15.143 2.7689 15.092 2.82001L12.8043 5.106C12.7275 5.18272 12.6234 5.22581 12.5148 5.22581C12.4062 5.22581 12.3021 5.18272 12.2253 5.106C12.0656 4.94667 12.0743 4.67734 12.2336 4.518L14.5113 2.24034C14.5623 2.18928 14.6025 2.12839 14.6293 2.06135C14.6561 1.99431 14.6691 1.92252 14.6673 1.85034C14.6656 1.77816 14.6492 1.70708 14.6192 1.64142C14.5891 1.57575 14.5461 1.51687 14.4926 1.46834C14.3961 1.38079 14.2703 1.33262 14.14 1.33334C13.9923 1.33344 13.8507 1.39219 13.7463 1.49667L11.4706 3.772C11.3938 3.84872 11.2897 3.89182 11.1811 3.89182C11.0726 3.89182 10.9684 3.84872 10.8916 3.772C10.7323 3.61267 10.7406 3.34334 10.9 3.18401L13.1776 0.907007C13.2287 0.855948 13.2688 0.795055 13.2957 0.728017C13.3225 0.660979 13.3354 0.589192 13.3337 0.517009C13.3319 0.444825 13.3155 0.373748 13.2855 0.308085C13.2555 0.242421 13.2124 0.183539 13.159 0.135008C13.0624 0.0474617 12.9366 -0.000709186 12.8063 7.89221e-06C12.6586 0.000182703 12.517 0.058922 12.4126 0.163341L9.84763 2.72834C9.59911 2.97546 9.40209 3.26943 9.26797 3.59322C9.13385 3.91702 9.0653 4.2642 9.06629 4.61467V4.889C9.06635 4.95914 9.05257 5.0286 9.02574 5.09341C8.99892 5.15821 8.95957 5.21709 8.90996 5.26667L7.72296 6.454C7.71058 6.4664 7.69587 6.47623 7.67969 6.48294C7.6635 6.48965 7.64615 6.49311 7.62863 6.49311C7.61111 6.49311 7.59376 6.48965 7.57757 6.48294C7.56138 6.47623 7.54668 6.4664 7.53429 6.454L1.7583 0.677674C1.65861 0.577871 1.52344 0.521627 1.38238 0.521252C1.24132 0.520877 1.10585 0.576402 1.00563 0.675674C0.500635 1.17601 0.230968 1.88234 0.230968 2.71801C0.227635 4.098 0.952968 5.68467 2.12397 6.854L4.9723 9.70233C5.37713 10.1063 5.92569 10.3333 6.49763 10.3333C6.67996 10.3334 6.86155 10.3101 7.03796 10.264C7.08225 10.2524 7.12784 10.2465 7.17363 10.2463C7.30752 10.2464 7.43646 10.297 7.53463 10.388L7.91429 10.7387C8.01222 10.8387 8.06723 10.973 8.06763 11.113V11.2977C8.06665 11.7175 8.23164 12.1206 8.52663 12.4193L11.5283 15.4717L11.5313 15.475C11.8644 15.8081 12.3163 15.9952 12.7874 15.9952C13.2585 15.9952 13.7103 15.808 14.0435 15.4748C14.3766 15.1417 14.5637 14.6898 14.5637 14.2187C14.5636 13.7476 14.3764 13.2958 14.0433 12.9627L9.54396 8.46333C9.53156 8.45095 9.52173 8.43625 9.51502 8.42006C9.50831 8.40387 9.50485 8.38652 9.50485 8.369C9.50485 8.35148 9.50831 8.33413 9.51502 8.31794C9.52173 8.30176 9.53156 8.28705 9.54396 8.27467L10.731 7.08767C10.7805 7.0381 10.8393 6.99877 10.9041 6.97195C10.9688 6.94513 11.0382 6.93132 11.1083 6.93134H11.3833Z"
                    fill="black"
                  />
                  <path
                    d="M6.49766 11.4C5.64378 11.3982 4.82502 11.0599 4.219 10.4583L3.757 9.99633C3.70701 9.94646 3.63928 9.91846 3.56866 9.91846C3.49805 9.91846 3.43032 9.94646 3.38033 9.99633L0.546999 12.815C0.0419995 13.32 -0.138334 14.0633 0.111666 14.7913C0.125658 14.8323 0.142247 14.8724 0.161333 14.9113C0.497666 15.6 1.15033 16 1.86433 16C2.10988 16.0006 2.3531 15.9525 2.57991 15.8584C2.80673 15.7643 3.01262 15.6262 3.18566 15.452L6.96433 11.6553C6.98023 11.6391 6.99241 11.6196 7.00001 11.5982C7.00761 11.5768 7.01045 11.554 7.00833 11.5313V11.5227C7.00685 11.5019 7.00117 11.4816 6.99164 11.4631C6.98211 11.4445 6.96893 11.4281 6.95289 11.4148C6.93685 11.4015 6.91828 11.3916 6.89831 11.3857C6.87833 11.3798 6.85736 11.3779 6.83666 11.3803C6.72408 11.3928 6.61093 11.3994 6.49766 11.4Z"
                    fill="black"
                  />
                </svg>
              ) : (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="17"
                  height="16"
                  viewBox="0 0 17 16"
                  fill="none"
                >
                  <path
                    d="M5.79592 1.06069C5.88966 0.898216 5.91501 0.705158 5.86641 0.523989C5.8178 0.342819 5.69922 0.188379 5.53674 0.0946429C5.37427 0.000906802 5.18121 -0.0244467 5.00004 0.0241597C4.81887 0.0727661 4.66443 0.191351 4.57069 0.353827L3.00616 3.06348H1.88461C1.47518 3.06356 1.07692 3.19694 0.750027 3.44345C0.423136 3.68997 0.185395 4.03621 0.0727488 4.42983C-0.039897 4.82345 -0.0213221 5.24305 0.125665 5.62518C0.272652 6.0073 0.540059 6.33118 0.887454 6.54785C0.942188 6.58126 1.00523 6.59858 1.06935 6.5978H14.9522C15.0163 6.59858 15.0793 6.58126 15.1341 6.54785C15.4815 6.33118 15.7489 6.0073 15.8959 5.62518C16.0429 5.24305 16.0614 4.82345 15.9488 4.42983C15.8361 4.03621 15.5984 3.68997 15.2715 3.44345C14.9446 3.19694 14.5464 3.06356 14.1369 3.06348H13.0154L11.4508 0.353827C11.4044 0.273377 11.3426 0.202857 11.269 0.146292C11.1953 0.0897277 11.1112 0.0482272 11.0215 0.0241597C10.9318 9.22946e-05 10.8382 -0.00607076 10.7461 0.00602279C10.654 0.0181163 10.5652 0.0482295 10.4848 0.0946429C10.4043 0.141056 10.3338 0.202861 10.2773 0.276528C10.2207 0.350196 10.1792 0.434283 10.1551 0.523989C10.1311 0.613695 10.1249 0.707263 10.137 0.79935C10.1491 0.891438 10.1792 0.980242 10.2256 1.06069L11.383 3.06348H4.63949L5.79592 1.06069Z"
                    fill="black"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M14.9239 8.2332C14.9287 8.20607 14.9276 8.17822 14.9204 8.1516C14.9133 8.12498 14.9005 8.10024 14.8828 8.07912C14.8651 8.058 14.843 8.04103 14.818 8.02938C14.793 8.01774 14.7658 8.01171 14.7382 8.01172H1.28331C1.25575 8.01171 1.22853 8.01774 1.20356 8.02938C1.17859 8.04103 1.15647 8.058 1.13877 8.07912C1.12107 8.10024 1.10821 8.12498 1.1011 8.1516C1.094 8.17822 1.09281 8.20607 1.09764 8.2332L2.04012 13.6035C2.13578 14.1481 2.40173 14.6484 2.79972 15.0324C3.19771 15.4163 3.70722 15.6641 4.25497 15.7401C6.7469 16.0869 9.27465 16.0869 11.7666 15.7401C12.3143 15.6641 12.8238 15.4163 13.2218 15.0324C13.6198 14.6484 13.8858 14.1481 13.9814 13.6035L14.9239 8.2332ZM6.83267 10.1323C6.83267 9.94484 6.75819 9.76505 6.62563 9.63249C6.49307 9.49992 6.31327 9.42545 6.1258 9.42545C5.93833 9.42545 5.75854 9.49992 5.62597 9.63249C5.49341 9.76505 5.41894 9.94484 5.41894 10.1323V12.0173C5.41894 12.2048 5.49341 12.3846 5.62597 12.5171C5.75854 12.6497 5.93833 12.7242 6.1258 12.7242C6.31327 12.7242 6.49307 12.6497 6.62563 12.5171C6.75819 12.3846 6.83267 12.2048 6.83267 12.0173V10.1323ZM9.89575 9.42545C10.0832 9.42545 10.263 9.49992 10.3956 9.63249C10.5281 9.76505 10.6026 9.94484 10.6026 10.1323V12.0173C10.6026 12.2048 10.5281 12.3846 10.3956 12.5171C10.263 12.6497 10.0832 12.7242 9.89575 12.7242C9.70828 12.7242 9.52848 12.6497 9.39592 12.5171C9.26336 12.3846 9.18888 12.2048 9.18888 12.0173V10.1323C9.18888 9.94484 9.26336 9.76505 9.39592 9.63249C9.52848 9.49992 9.70828 9.42545 9.89575 9.42545Z"
                    fill="black"
                  />
                </svg>
              )}
            </Grid>
            <Grid
              style={{
                display: "flex",
                alignItems: "center",
                paddingLeft: "12px",
              }}
              item
              xs={10.5}
              sm={10.5}
              md={10.5}
            >
              <h2 style={{ fontSize: "18px", fontWeight: 700, color: "#000" }}>
                {bussinessType}
              </h2>
            </Grid>
          </Grid>
        )}

        <Grid
          container
          style={{ paddingTop: "15px", display: "flex", alignItems: "center" }}
        >
          <Grid
            item
            xs={2}
            sm={1}
            md={1}
            lg={1}
            xl={1}
            style={{ display: "flex", alignItems: "center" }}
          >
            <img
              style={{
                width: "54px",
                height: "53px",
                maxHeight: "100%",
                maxWidth: "100%",
                borderRadius: "10px",
                border: "1px solid rgba(0, 0, 0, 0.06)",
              }}
              alt="Restaurant"
              src={props?.Cart?.storeid?.storeLogoUrl}
            />
          </Grid>

          <Grid
            style={{
              display: "flex",
              flexDirection: "column",
              paddingLeft: "8px",
            }}
            item
            xs={6}
            sm={10}
            md={9}
            lg={9}
            xl={9}
          >
            <span
              style={{
                color: "#000",
                fontSize: "14px",
                fontWeight: 650,
              }}
            >
              {props?.Cart?.storeid?.storeName}
            </span>
            <span
              style={{
                paddingTop: "7px",
                color: "#061303",
                fontSize: "12px",
                fontWeight: 700,
              }}
            >
              {storeLocation}
            </span>
          </Grid>

          <Grid
            item
            xs={12}
            sm={2}
            md={2}
            lg={2}
            xl={2}
            style={{
              display: "flex",
              alignItems: "center",
              textAlign: "right",
              justifyContent: "flex-end",
            }}
          >
            <div style={{ marginRight: "13px" }}>
              <PhoneIcon />
            </div>

            <div style={{ whiteSpace: "nowrap" }}>
              <p
                style={{
                  color: "#000",
                  fontFamily: "Nunito",
                  fontSize: "0.875rem",
                  fontStyle: "normal",
                  fontWeight: 700,
                  lineHeight: "100%",
                }}
              >
                {storeManagerPhone}
              </p>
            </div>
          </Grid>
        </Grid>
      </Card>
    </>
  );
};

export default StoreInfo;
